import { action } from 'satcheljs/lib/legacy';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';

export default action('setFindResultSet')(function setFindResultSet(
    viewstate: FindControlViewState,
    findResultSet: FindRecipientPersonaType[]
) {
    viewstate.findResultSet = findResultSet;
});
